import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { aiProactiveMessages } from '@atlaskit/editor-common/ai-messages';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Stack, Text } from '@atlaskit/primitives/compiled';

import ReloadSuggestionsImageDark from '../assets/reload-suggestions/dark.svg';
import ReloadSuggestionsImageLight from '../assets/reload-suggestions/light.svg';

export const ReloadSuggestionsState = ({
	handleReloadSuggestions,
	isEditorDisabled,
}: {
	handleReloadSuggestions: () => void;
	isEditorDisabled?: boolean;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	// eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details
	<Image src={ReloadSuggestionsImageLight} srcDark={ReloadSuggestionsImageDark} />;

	return (
		<Stack space="space.200" alignInline="center" grow="fill">
			{/* eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details */}
			<Image src={ReloadSuggestionsImageLight} srcDark={ReloadSuggestionsImageDark} />
			<Stack space="space.200" alignInline="center">
				<Heading color="color.text" size="small">
					{formatMessage(aiProactiveMessages.reloadSuggestionsStateTitle)}
				</Heading>
				<Text align="center" color="color.text" size="medium">
					{formatMessage(aiProactiveMessages.reloadSuggestionsStateDescription)}
				</Text>
				<Button
					appearance="default"
					onClick={handleReloadSuggestions}
					isDisabled={isEditorDisabled}
				>
					{formatMessage(aiProactiveMessages.reloadSuggestionsButtonLabel)}
				</Button>
			</Stack>
		</Stack>
	);
};
